import React, { useState } from 'react'
import { Button, Row, Col, Table} from "react-bootstrap"
import { withTranslation } from 'react-i18next';
import { BsFillTrashFill } from 'react-icons/bs';
import Delete from '../../api/Delete';
import { REMISION_DELETE } from '../../api/Routes';
import ComponentModalErrorSever from '../ComponentModalErrorSever';
import ModalRemisionesCatalogo from './ModalRemisionesCatalogo';
import {canEditDoctor} from "../../utils/isDoctor";

function DoctorRemisionesColombia({ t, citaID, auth, remisiones, readOnly, cita }){
    const [show, setShow] = useState(false);
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)
    const [remisioness, setRemisiones] = useState(remisiones)

    const deleteObj = (id) =>{
        Delete({url: `${REMISION_DELETE}/${id}`, access_token: auth.data.access_token})
        .then(response=>{
            if(response.data.data.data){
                let arr = remisioness.filter(el=>el.id!==id)
                setRemisiones(arr)
            }
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return (
        <div className="p-3 pt-4 position-relative">
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
            <ModalRemisionesCatalogo
                citaID={citaID}
                show={show}
                setItems={setRemisiones}
                setShow={setShow}
                auth={auth}
                setShowModalError={setShowModalError}
                setErrorServer={setErrorServer}
            />
            {!readOnly && canEditDoctor(cita, auth) && <Row className="mt-3">
                <Col>
                    <Button onClick={e=>setShow(true)} variant="outline-primary" size="sm">{t('agregar')} </Button>
                </Col>
            </Row>}
            <Row className="mt-3">
                <Col>
                    <Table size="sm">
                        <thead>
                            <tr>
                                <th>{t('remisiones_agregados')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                remisioness.length === 0 ? 
                                <tr><td>{t('lista_vacia')}</td></tr> :
                                remisioness.map((item,i)=>(
                                    <tr key={i}>
                                        <td>{item.nombre}</td>
                                        {canEditDoctor(cita, auth) &&
                                        <td width="5%">{!readOnly && <Button type="button" variant="outline-danger" size="sm" className="py-0 px-1" onClick={e=>deleteObj(item.id)}><BsFillTrashFill /></Button>}</td>
                                        }
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>

        </div>
    )
}

export default withTranslation()(DoctorRemisionesColombia)